import { render } from "./messaging_setting.vue?vue&type=template&id=0a07cdb9"
import script from "./messaging_setting.vue?vue&type=script&lang=js"
export * from "./messaging_setting.vue?vue&type=script&lang=js"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__